import React from 'react'
import { X } from 'lucide-react'
import styles from '../../_css/Agency.module.css'
import { font } from '../Simulation/constants'

/** Generic popup with a single confirm action. */
function GeneratePersonaConfirmModal({
  open,
  onClose,
  onConfirm,
  disabled,
  title = "Please wait",
  message = "Generating persona might take some time. Please wait.",
}) {
  if (!open) return null

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.()
  }

  const overlayStyle = {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
  }
  const modalStyle = {
    maxWidth: 400,
    width: '100%',
    background: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 12,
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 32px)',
  }

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="generate-persona-modal-title"
      style={overlayStyle}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={modalStyle}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '18px 20px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
          }}
        >
          <h2 id="generate-persona-modal-title" style={{ fontSize: 17, fontWeight: 700, color: '#363636', margin: 0, fontFamily: font }}>
            {title}
          </h2>
          <button type="button" onClick={onClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, padding: 0, border: 'none', background: 'rgba(0, 0, 0, 0.06)', borderRadius: 8, color: '#6b6b6b', cursor: 'pointer' }} aria-label="Close">
            <X size={20} />
          </button>
        </div>
        <div style={{ padding: '18px 20px 20px', fontFamily: font }}>
          <p style={{ margin: 0, fontSize: 13, color: '#5a5a5a', lineHeight: 1.5 }}>
            {message}
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 18 }}>
            <button
              type="button"
              onClick={onConfirm}
              disabled={disabled}
              style={{
                padding: '8px 16px',
                borderRadius: 8,
                border: 'none',
                background: 'linear-gradient(135deg, #ff4b4f, #dc2626)',
                color: '#fff',
                fontSize: 13,
                fontWeight: 600,
                fontFamily: font,
                cursor: disabled ? 'not-allowed' : 'pointer',
                boxShadow: '0 4px 14px rgba(255, 75, 79, 0.25)',
                opacity: disabled ? 0.65 : 1,
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeneratePersonaConfirmModal
